import React from 'react';
import ReactDOM from 'react-dom';
import './CSS/index.css';
import Navbar from './Navbar';
import Title from './Title';
import Sidelinks from './Sidelinks';
import github from './images/GithubFooter.png';
import linkedin from './images/LinkedinFooter.png';
import Twitter from './images/twitter.png';
import instagram from './images/instagram.png';

import linkedinsidelink from './images/linkedin.png';
import Githubsidelink from './images/github.png';
import ImageOfPlane from './images/PaperPlane.png';
import bgImageAboutMe from './images/Profile.png';
import AboutMePic from './AboutMePicture';

import JavaScriptIcon from './images/JavaScriptIcon.png';
import HtmlIcon from './images/HtmlIcon.png';
import CssIcon from './images/CssIcon.png';
import BootstrapIcon from './images/BootstrapIcon.png';
import ReactIcon from './images/ReactIcon.png';

import imageOfMe from './images/Tani.jpg';
import AboutMeShadow from './AboutMeShadow';
import ParagraphTitleAboutme from './ParagraphTitleAboutme';
import ParagraphTextAboutMe from './ParagraphTextAboutMe';
import ResumeButton from './ResumeButton';
import MySkillsTitle from './MySkillsTitle';
import MyProjects from './MyProjects';
import ProjectDescriptions from './ProjectTemplates';

import IconTemplates from './IconTemplates';
import ContactMeTitle from './ContactMeTitle';

import Email from './Email';
import ArrowCircle from './ArrowCircle';
import Buttonthemainpage from './Buttonthemainpage';
ReactDOM.render(
  <React.StrictMode>
    <Navbar />
  </React.StrictMode>,
  document.getElementById('navbar')
);

ReactDOM.render(
  <React.StrictMode>
    <Title />
  </React.StrictMode>,
  document.getElementById('title')
);

ReactDOM.render(
  <React.StrictMode>
    <Sidelinks url="https://github.com/Tanya-design93" image={github} socialMedia="img-fluid" ml-auto anchorClass="socialHyperlink"/>
  </React.StrictMode>,
  document.getElementById('socialMedia')
);

ReactDOM.render(
  <React.StrictMode>
    <Sidelinks url="https://www.linkedin.com/in/tanya-spivak-468ba8a4" image={linkedin} socialMedia="img-fluid" anchorClass="socialHyperlink"/>
  </React.StrictMode>,
  document.getElementById('Linkedin')
);




ReactDOM.render(
  <React.StrictMode>
    <AboutMePic photoOfMe={imageOfMe} />
  </React.StrictMode>,
  document.getElementById('aboutMe')
);

ReactDOM.render(
  <React.StrictMode>
    <AboutMeShadow/>
  </React.StrictMode>,
  document.getElementById('aboutMeShadow')
);

ReactDOM.render(
  <React.StrictMode>
    <ParagraphTitleAboutme/>
  </React.StrictMode>,
  document.getElementById('aboutMeTitle')
);

ReactDOM.render(
  <React.StrictMode>
    <ParagraphTextAboutMe/>
  </React.StrictMode>,
  document.getElementById('aboutMeParagraph')
);

ReactDOM.render(
  <React.StrictMode>
    <ResumeButton/>
  </React.StrictMode>,
  document.getElementById('resumeButton')
);

ReactDOM.render (
  <React.StrictMode>
    <MySkillsTitle/>
  </React.StrictMode>,
  document.getElementById('MySkills')
);

ReactDOM.render (
  <React.StrictMode>
    <MyProjects/>
  </React.StrictMode>,
  document.getElementById('MyProjects')
);

ReactDOM.render(
  <React.StrictMode>
    <IconTemplates iconId="JavaScriptIcon" iconImage={JavaScriptIcon} iconDescription="This is an icon of Javascript." language="JavaScript" />
  </React.StrictMode>,
  document.getElementById('JSIcon')
);
ReactDOM.render(
  <React.StrictMode>
    <IconTemplates iconId="Html" iconImage={HtmlIcon} iconDescription="This is an icon of Html." language="HTML5" />
  </React.StrictMode>,
  document.getElementById('HtmlIcon')
);
ReactDOM.render(
  <React.StrictMode>
    <IconTemplates iconId="Css" iconImage={CssIcon} iconDescription="This is an icon of Css." language="CSS3"  />
  </React.StrictMode>,
  document.getElementById('CssIcon')
);

ReactDOM.render(
  <React.StrictMode>
    <IconTemplates iconId="Bootstrap" iconImage={BootstrapIcon} iconDescription="This is an icon of Bootstrap." language="Bootstrap" />
  </React.StrictMode>,
  document.getElementById('BootstrapIcon')
);
ReactDOM.render(
  <React.StrictMode>
    <IconTemplates iconId="React.js" iconImage={ReactIcon} iconDescription="This is an icon of React."language="React.js"  />
  </React.StrictMode>,
  document.getElementById('ReactIcon')
);

ReactDOM.render (
  <React.StrictMode>
    <ContactMeTitle/>
  </React.StrictMode>,
  document.getElementById('ContactMeTitle')
);





ReactDOM.render (
  <React.StrictMode>
    <Email/>
  </React.StrictMode>,
  document.getElementById('Email')
);

ReactDOM.render (
  <React.StrictMode>
    <ArrowCircle/>
  </React.StrictMode>,
  document.getElementById('Arrowdowncircle')
);



